import { useEffect, useRef } from 'react'
import 'broadcastchannel-polyfill'

// Use a BroadcastChannel to dispatch messages to multiple browser tabs
export const useBroadcastChannel = (channel: string) => {
  const bc = useRef<BroadcastChannel>(new BroadcastChannel(channel))

  useEffect(() => {
    const instance = bc.current
    return () => {
      instance.close()
    }
  }, [channel])

  return bc.current
}
